import { VOICE_SOURCE_DOCUMENT_SOURCES } from "core/consts";
import { FileHISStateful, FileState, Filev2 } from "core/types";

export function isFileHISStateful(
  file: FileState | undefined,
): file is FileHISStateful {
  return !!(file as FileHISStateful)?.document_id;
}

export function isFileV2(file: FileState | undefined): file is Filev2 {
  return (file as Filev2)?.category != null;
}

export function isVoiceSourceDocumentSource(
  source: string | null | undefined,
): boolean {
  return (VOICE_SOURCE_DOCUMENT_SOURCES as readonly string[]).includes(
    source ?? "",
  );
}
